<template>
  <div :class="['modalHowitsworks', isShow ? 'active' : '']">
    <div class="mainContent">
      <div class="icon">
        <img src="@/assets/images/card_giftcard.svg" alt=""/>
      </div>
      <div class="title">
        {{ 
            referralPoints && referralPoints > 0
            ? lbl.fgf.welcomepoint + referralPoints + lbl.fgf.pointmodal
            : lbl.fgf.invite 
          }}
      </div>
      <div class="content">
        {{ lbl.fgf.welcomepointtext.split('_')[0] }}
        {{ storename }}
        {{ lbl.fgf.welcomepointtext.split('_')[1] }}
      </div>
      <div class="btnCon">
        <button
          :style="{
            backgroundColor: btnBGColor,
            color: btnColor,
            border: '1px solid ' + btnBGColor,
          }"
          @click="modalHandler(false, true)"
        >
          {{ lbl.fgf.closebtn }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import CommonMixin from '@/mixin/CommonMixin'
import ResponsiveMixin from '@/mixin/ResponsiveMixin'

export default {
  name: 'FGFmodal',
  components: {},
  mixins: [CommonMixin, ResponsiveMixin],
  props: {
    isShow: Boolean,
    btnColor: String,
    btnBGColor: String,
    storename: String,
    referralPoints: String,
    modalHandler: Function,
  },
  data() {
    return {}
  },
  created() {},
  mounted() {},
  methods: {},
  }
</script>

<style lang="scss" scoped>
.modalHowitsworks {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 126;
  visibility: hidden;
  opacity: 0;
  transition: all 0.15s ease-in;
  &.active {
    visibility: visible;
    opacity: 1;
  }
  .mainContent {
    font-size: 18px;
    width: 90%;
    max-width: 376px;
    background-color: white;
    padding: 24px;
    border-radius: 10px;
    .icon {
      margin: 34px auto 24px auto;
      text-align: center;
    }
    .title {
      font-size: 18px;
      text-align: center;
    }
    .content {
      margin-top: 8px;
      font-size: 16px;
      color: #757575;
      text-align: center;
    }
    .btnCon {
      display: flex;
      justify-content: center;
      margin-top: 34px;
      button {
        height: 45px;
        width: 100%;
        font-size: 18px;
        font-weight: 500;
        border-radius: 100px;
      }
    }
  }
}
</style>
